<template>
  <div class="carouselModule">
    <!--Carousel Wrapper-->
    <div v-if="images.length === 0">
      <div class="imagePlaceholder"></div>
    </div>
    <div id="carousel-activity-1" v-if="images.length" class="carousel slide carousel-fade z-depth-1" data-ride="carousel" :data-interval="interval">
      <!--Indicators-->
      <ol class="carousel-indicators">
        <li data-target="#carousel-example-1" v-bind:class="{ active: isActive(index) }" v-for="(image, index) in images" data-slide-to="index"></li>
      </ol>
      <!--/.Indicators-->

      <!--Slides-->
      <div class="carousel-inner" role="listbox">
        <!--First slide-->
        <div class="carousel-item" v-bind:class="{ active: isActive(index) }" v-for="(image, index) in images">
          <div class="image" v-bind:style="{backgroundImage: 'url('+image.large_path+')'}" ></div>
          <!--img :src="image.large_path" /-->
        </div>
        <!--/First slide-->
      </div>
      <!--/.Slides-->

      <!--Controls-->
      <a class="left carousel-control" href="#carousel-activity-1" role="button" data-slide="prev">
        <span class="icon-prev" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="right carousel-control" href="#carousel-activity-1" role="button" data-slide="next">
        <span class="icon-next" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
      <!--/.Controls-->
    </div>
    <!--/.Carousel Wrapper-->
  </div>
</template>

<script>

export default {
  name: 'Carousel',
  components: {
  },
  data() {
    return {
      active: 0,
    };
  },
  methods: {
    isActive(index) {
      if (index === this.active) {
        return 'active';
      }
      return false;
    },
  },
  props: {
    images: { default: [] },
    interval: { default: false },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.imagePlaceholder {
  background: url('/static/img/no-image-big.jpg') center center;
  background-size: cover;
  width: 100%;
}
.carouselModule {
  z-index: 1;
}
.carouselModule, .carousel, .carousel-item, .imagePlaceholder {
  position: relative;
}
.carousel {
  /*margin: 30px 15px;*/
  /*border: 20px solid rgba(255,255,255, 0.1);
  border-bottom-width: 20px;*/
}
.carousel-inner {
  position: relative;
  padding-top: 66.66%;
}
.image, .carousel-item {
  position: absolute;
  height: 100%;
  top: 0;
  left: 0;
  width: 100%;
}

.image {
  background-position: center center;
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// Carousel.vue?273b95eb